import classNames from 'classnames';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { LogHelpers } from '../../service/LogHelpers/LogHelpers';
import { SimpleMultipliersHelpers } from '../../service/SimpleMultipliersHelpers/SimpleMultipliersHelpers';
import { OutputCategory } from '../../typings/graphql-log';
import { ChangedOptions, SimpleMultiplierGroups } from '../../typings/log';
import {
    ExpandableCell,
    ExpandableProps
} from '../ExpandableCell/ExpandableCell';

import './SimpleMultiplierCell.css';

export interface SimpleMultiplierProps extends ExpandableProps {
    diff: SimpleMultiplierGroups;
    type: OutputCategory;
}

export class SimpleMultiplierCell extends ExpandableCell<
    SimpleMultiplierProps
> {
    protected getContent() {
        const {
            diff: { type }
        } = this.props;

        return (
            <div
                className={Bem.cls('simple-multiplier-cell')}
                ref={ref => (this.cell = ref)}
            >
                {type === ChangedOptions.modified
                    ? this.getMultipliersDiff()
                    : this.getMultipliersSimple()}
            </div>
        );
    }

    private getMultipliersSimple = (): React.ReactNode => {
        const {
            diff: { value, type },
            type: category
        } = this.props;
        const correctionSign = LogHelpers.getSign(value),
            correctionValue = Math.abs(value - LogHelpers.noCorrectionValue);

        return (
            <div
                className={classNames(
                    Bem.cls('simple-multiplier-cell', Bem.beminize(type)),
                    Bem.cls('simple-multiplier-cell', 'row')
                )}
            >
                {correctionSign}
                {correctionValue}
                %&nbsp;
                {SimpleMultipliersHelpers.getSimpleMultiplier(category)}
            </div>
        );
    };

    private getMultipliersDiff = (): React.ReactNode => {
        const {
                diff: { value, compareValue },
                type
            } = this.props,
            correctionSign = LogHelpers.getSign(value),
            multiplierValue = Math.abs(value - LogHelpers.noCorrectionValue),
            compareSign = LogHelpers.getSign(compareValue),
            compareMultiplierValue = Math.abs(
                compareValue - LogHelpers.noCorrectionValue
            );

        return (
            <div>
                <span className={Bem.cls('simple-multiplier-cell', 'removed')}>
                    {compareSign}
                    {compareMultiplierValue}
                    %&nbsp;
                </span>
                &nbsp;
                <span className={Bem.cls('simple-multiplier-cell', 'added')}>
                    {correctionSign}
                    {multiplierValue}
                    %&nbsp;
                </span>
                &nbsp;
                {SimpleMultipliersHelpers.getSimpleMultiplier(type)}
            </div>
        );
    };
}
